import React from 'react';
import { SmartLink } from '@/app/_components/core/smart-link';
import { cn } from '@/app/_lib/utils';

export interface TextLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  title?: string;
  target?: string;
  download?: boolean | string;
  /** Passive tracking key rendered as `data-track-id` (from RTE links). */
  'data-track-id'?: string;
}

/**
 * TextLink for inline links within copytext.
 * Inherits font styles from parent and adds underline.
 *
 * Uses SmartLink internally for automatic handling of:
 * - External links (opens in new tab)
 * - Internal links (Next.js client-side navigation)
 * - Email/phone links
 * - Downloads (with toast feedback)
 */
export function TextLink({ href, children, className, title, target, download, 'data-track-id': dataTrackId }: TextLinkProps) {
  return (
    <SmartLink
      href={href}
      title={title}
      target={target}
      download={download}
      className={cn('text-primary underline underline-offset-2', className)}
      data-track-id={dataTrackId}
    >
      {children}
    </SmartLink>
  );
}
